<template>
  <modal :show="show" size-class="size-s" :onClose="onClose">
    <div class="user-delete-modal">
      <h2>
        <rp-sprite name="warning_rounded" size="size-36" />
        <span>Delete <b>{{user}}</b>?</span>
      </h2>
      <div class="breadcrumbs-actions">

        <rp-button
          size="size-s"
          border-radius
          @click="onClose"
          button-type="normal">
          Cancel
        </rp-button>

        <rp-button
          size="size-s"
          border-radius
          @click="onConfirm"
          button-type="primary">
          Confirm
        </rp-button>

      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal'
import RpSprite from 'raypro_ui/src/components/ui/Sprite'
import RpButton from 'raypro_ui/src/components/ui/inputs/Button'

export default {
  components: {
    Modal,
    RpSprite,
    RpButton
  },
  props: {
    show: {type: Boolean},
    user: {type: String},
    onClose: {
      type: Function,
      required: true
    },
    onConfirm: {
      type: Function,
      required: true
    }
  }
}
</script>

<style lang="sass">
@import 'raypro_ui/src/styles/base/_variables.sass'

.user-delete-modal
  padding-top: 1rem
  position: relative
  padding: 30px

  h2
    display: flex
    align-items: center
    padding-bottom: 30px

    .sprite
      margin-right: 2rem

      svg
        fill: $color-error

    span
      font-size: 1.8rem
      font-weight: $font-medium

  .actions
    display: flex
    justify-content: space-between
    align-items: center
</style>



// WEBPACK FOOTER //
// src/components/UserDeleteModal.vue